
import React, { useEffect } from 'react';

// Update global type declaration to match what's in Newsletter.tsx
declare global {
  interface Window {
    jQuery: any;
    $mcj: any;
    fnames: string[]; 
    ftypes: string[]; 
  }
}

// This component handles loading Mailchimp scripts
const MailchimpLoader: React.FC = () => {
  useEffect(() => {
    let jQueryScript: HTMLScriptElement | null = null;
    let mcCss: HTMLLinkElement | null = null;
    let mcScript: HTMLScriptElement | null = null;
    
    // Check if scripts are already loaded
    const checkExistingScripts = () => {
      return !!document.querySelector('script[src*="mc-validate.js"]');
    };
    
    if (!checkExistingScripts()) {
      // Add Mailchimp CSS
      mcCss = document.createElement('link');
      mcCss.rel = 'stylesheet';
      mcCss.type = 'text/css';
      mcCss.href = '//cdn-images.mailchimp.com/embedcode/classic-061523.css';
      document.head.appendChild(mcCss);
      
      // Add jQuery if not already present
      if (!window.jQuery) {
        jQueryScript = document.createElement('script');
        jQueryScript.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
        jQueryScript.integrity = 'sha256-/xUj+3OJU5yExlq6GSYGSHk7tPXikynS7ogEvDej/m4=';
        jQueryScript.crossOrigin = 'anonymous';
        jQueryScript.onload = () => {
          // Add Mailchimp validation script after jQuery is loaded
          mcScript = document.createElement('script');
          mcScript.type = 'text/javascript';
          mcScript.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
          mcScript.onload = initializeMailchimp;
          document.head.appendChild(mcScript);
        };
        document.head.appendChild(jQueryScript);
      } else {
        // jQuery already exists, directly add Mailchimp script
        mcScript = document.createElement('script');
        mcScript.type = 'text/javascript';
        mcScript.src = '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js';
        mcScript.onload = initializeMailchimp;
        document.head.appendChild(mcScript);
      }
    }
    
    function initializeMailchimp() {
      if (window.jQuery) {
        // Initialize Mailchimp form validation
        window.fnames = window.fnames || [];
        window.ftypes = window.ftypes || [];
        window.fnames[0] = 'EMAIL';
        window.ftypes[0] = 'email';
        window.fnames[1] = 'FNAME';
        window.ftypes[1] = 'text';
        window.fnames[7] = 'CONSENT';
        window.ftypes[7] = 'text';
        window.$mcj = window.jQuery.noConflict(true);
        
        console.log("Mailchimp scripts initialized successfully");
      }
    }
    
    // Cleanup on unmount to avoid memory leaks and duplicate scripts
    return () => {
      // We should generally not remove scripts once they're loaded
      // as they may be used by multiple components
      // Just clean up references
      jQueryScript = null;
      mcCss = null;
      mcScript = null;
    };
  }, []);

  return null; // This component doesn't render anything
};

export default MailchimpLoader;
